import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { BatchDetail } from "./routes/BatchDetail";
import { BatchesPage, BatchesPlaceholder } from "./routes/BatchesPage";
import { DeviceDetail } from "./routes/DeviceDetail";
import { DriverDetail } from "./routes/DriverDetail";
import { LoadDetail } from "./routes/LoadDetail";
import { LoadsPage, LoadsPlaceholder } from "./routes/LoadsPage";
import { OutboundPage } from "./routes/OutboundPage";
import { SearchPage } from "./routes/SearchPage";

// Each list is a route with its detail nested inside, so picking a row never replaces the
// list.
export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/loads" replace />} />

        <Route path="/loads" element={<LoadsPage />}>
          <Route index element={<LoadsPlaceholder />} />
          <Route path=":loadGuid" element={<LoadDetail />} />
        </Route>

        <Route path="/batches" element={<BatchesPage />}>
          <Route index element={<BatchesPlaceholder />} />
          <Route path=":batchGuid" element={<BatchDetail />} />
        </Route>

        <Route path="/drivers/:driverGuid" element={<DriverDetail />} />
        <Route path="/devices/:deviceGuid" element={<DeviceDetail />} />
        <Route path="/outbound" element={<OutboundPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<Navigate to="/loads" replace />} />
      </Route>
    </Routes>
  );
}
